<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 18/2/2021
  -->

<template>
	<div class="qwoach-form my-5">
		<div v-if="docSignDocument">
			{{docSignDocument.name}} <qw-button type="circle" class="ml-3" icon="icon-trash" @click="onAgreementRemove"/>
		</div>
		<AgreementTemplatePickerView v-show="!docSignDocument" class="my-4"
						 @loadingStateChanged="onLoadingStateChanged"
						 @templatePicked="onAgreementTemplatePicked"/>

	</div>
</template>

<script>
import BaseWizardStep from "@/core/components/Wizard/BaseWizardStep.vue";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import {yesNoDialog} from "@/core/components/Dialogs/dialog";
import AgreementTemplatePickerView from "@/core/modules/DocSign/view/AgreementTemplatePickerView.vue";
import DocSignDocument from "@/core/modules/DocSign/data/DocSignDocument/DocSignDocument";
import {plainToClass, classToPlain} from "class-transformer";
import ContractProgramStep from "@shared/Program/ProgramStep/ContractProgramStep";
import CoachingProgram from "@shared/Program/CoachingProgram";

export default {
	name: "AddAgreementStep",
	components: {AgreementTemplatePickerView},
	extends: BaseWizardStep,

	data() {
		return {
			docSignDocument: null,
			form: {
				title: '',
				isGroup:false,
			},
			rules: {
				title: [
					{
						required: true,
						whitespace: false,
						message: 'Please specify name of this program',
						trigger: 'validate'
					},
				],
			},
		}
	},

	methods:{

		stepId(){
			return "add_agreement_step"
		},

		async restoreState(savedState){
			let programItem = plainToClass(CoachingProgram, savedState["create_program_step"])
			console.log("AddAgreementStep: restoreState: programItem = ", programItem)
			if(!programItem){
				return
			}
			let agreementRow = this.findAgreementRow(programItem)
			console.log("AddAgreementStep: agreementRow = ", agreementRow)
			if(agreementRow){
				this.docSignDocument = agreementRow.contract
			}
		},

		isStepRequired(){
			return false
		},

		onAgreementRemove(){
			this.docSignDocument = null
		},

		onLoadingStateChanged(isLoading){
			this.showLoading(isLoading, "Uploading the agreement. Please wait...")
		},

		onAgreementTemplatePicked(template){
			console.log("onAgreementTemplatePicked: template = ", template)
			if(!template){
				return
			}

			//cast DocSignTemplateItem to DocSignDocument
			this.docSignDocument = plainToClass(DocSignDocument, classToPlain(template))
			this.docSignDocument.parentTemplateId = template.parentTemplateId || template.id
			let contractId
			let dataItem = this.agreementRow
			if (dataItem.contract) {
				contractId = dataItem.contract.id
			} else {
				contractId = this.$dataManager.generateId()
			}
			this.docSignDocument.id = contractId

			this.docSignDocument.ownerProgramId = this.programItem.id;
			this.docSignDocument.ownerProgramStepId = dataItem.id
			this.docSignDocument.addOwner(this.programItem.id)
			this.docSignDocument.addOwner(dataItem.id)
			this.docSignDocument.addOwner(this.userProfile.id)

			this.nextStep()
		},

		async validateStep(){
			if(!this.docSignDocument){
				setTimeout(() => this.skipStep(), 100)
				// this.toastInfo("Please choose an agreement to proceed or press 'skip'")
				return false
			}
			return true
		},

		async onNextClicked(){
			let dataItem = this.agreementRow
			console.log("onNextClicked: dataItem = ", dataItem)
			// dataItem.stepVisibility = this.form.isNotePublic ? StepVisibility.PUBLIC : StepVisibility.PRIVATE;
			// dataItem.description = this.docSignDocument.labe;
			if(!dataItem.contract || dataItem.contract.id !== this.docSignDocument.id){
				dataItem.name = this.docSignDocument.name;
				dataItem.contract = await this.$dataManager.apiPostSetContract(this.docSignDocument)
				await this.$dataManager.updateProgram(this.programItem)
			}

		},

		async onSkipClicked(){
			let res = await yesNoDialog({
				title: "Proceed without agreement?",
				message: "If you skip this step, your clients won't be able to sign agreement as part of this program. <br/><br/>You will still be able to add an agreement later on.",
				yesButton: "Skip"
			})

			let dataItem = this.agreementRow

			console.log("onSkipClicked: res = ", res, ", dataItem.contract = ", dataItem.contract)
			if(res && dataItem.contract){
				// dataItem.stepVisibility = this.form.isNotePublic ? StepVisibility.PUBLIC : StepVisibility.PRIVATE;
				// dataItem.description = this.docSignDocument.labe;
				await this.$dataManager.apiPostDeleteContract(dataItem.contract)
				dataItem.name = null;
				dataItem.contract = null
				await this.$dataManager.updateProgram(this.programItem)
				this.docSignDocument = null
			}

			return res
		},

		stepDescription(){
			return this.docSignDocument ? this.docSignDocument.name : "No agreement"
		},

		findAgreementRow(programItem){
			let agreementRow
			programItem.findStep(step => step.isTypeContract(), (steps, index) => agreementRow = steps[index])
			if(!agreementRow){
				agreementRow = new ContractProgramStep()
				let section = programItem.programSteps[0]
				section.addProgramStep(agreementRow)
			}
			return agreementRow
		}

		// async validateForm(){
		// 	return true
		// }
	},

	computed:{
		programItem(){
			return this.getWizardDataByStepId("create_program_step")
		},

		agreementRow(){
			return this.findAgreementRow(this.programItem)
		}

	}
}
</script>

<style lang="scss">

</style>
